import { TCategoryState, CategoryAction } from "./category.state";
import { NormalizedCategory } from "~/types/search.types";
import { SearchActions } from "~/types/actions.enum";

// ✅ Category reducer logic
export const categoryReducer = (state: TCategoryState, action: CategoryAction): TCategoryState => {
    switch (action.type) {
        case SearchActions.SET_CATEGORY_ITEMS: {
            const updatedCategories = action.payload.map(item => ({
                ...item,
                selectedTopicIds: []
            }));

            return {
                ...state,
                categories: updatedCategories,
                size: action.payload.length,
                category: null
            };
        }

        case SearchActions.SET_ACTIVE_CATEGORY:
            return { ...state, category: action.payload };

        case SearchActions.SET_ACTIVE_CATEGORY_BY_KEY: {
            const { disclosureId, categoryProperty } = action.payload;
            const { property, value } = categoryProperty;

            const categoryItem =
                state.categories.find(
                    (item: NormalizedCategory) =>
                        item.disclosureId === disclosureId && item[property] === value
                ) ?? null;

            return { ...state, category: categoryItem };
        }

        case SearchActions.SET_IS_FETCHED: {
            const { categoryId, disclosureId, value } = action.payload;
            const categoryIdx = state.categories.findIndex(
                (item: NormalizedCategory) =>
                    item.exploreId === categoryId && item.disclosureId === disclosureId
            );

            if (categoryIdx < 0) {
                return state;
            }

            state.categories[categoryIdx].isFetched = value;
            return state;
        }

        case SearchActions.SET_CATEGORY_TOPIC: {
            const { categoryId, disclosureId, value, isSelected = true } = action.payload;
            let tempTopics: number[] = [];

            const categoryItem = state.categories.find(
                item => item.exploreId === categoryId && item.disclosureId === disclosureId
            );

            if (!categoryItem) {
                return { ...state };
            }

            if (isSelected) {
                tempTopics = [...categoryItem.selectedTopicIds, value];
                categoryItem.selectedTopicIds = [...new Set(tempTopics)];
            } else {
                tempTopics = categoryItem.selectedTopicIds.filter(item => item !== value);
                categoryItem.selectedTopicIds = tempTopics;
            }

            const updatedCategories = state.categories.map(item => {
                const { exploreId: itemCategoryId, disclosureId: itemDisclosureId } = item;

                if (
                    itemCategoryId === categoryId &&
                    itemDisclosureId === categoryItem.disclosureId
                ) {
                    return { ...item, selectedTopicIds: tempTopics.map(item => item) };
                }
                return item;
            });

            return { ...state, categories: updatedCategories };
        }

        case SearchActions.RESET_CATEGORY_TOPICS: {
            if (!action.payload) {
                return state;
            }

            const updatedCategories = state.categories.map(item => ({
                ...item,
                selectedTopicIds: []
            }));
            return { ...state, categories: updatedCategories };
        }

        default:
            return state;
    }
};
